<template>
  <div>
    <label class="d-block">
      {{ $t(config.label) }}
    </label>
    <validation-provider
      :name="$t(`commands.data_types.${config.name}`)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        :options="actionPlans"
        v-model="model"
        :clearable="false"
        :reduce="(val) => val.value"
        input-id="id_unit"
        :multiple="multiple"
        @input="$emit('input', model)"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(`commands.data_types.${config.hint}`) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: null,
    };
  },
  created() {
    this.model = this.value;
  },
  mounted() {
    if (!this.actionPlans.length) {
      store.dispatch("action_plan/getAll");
    }
  },
  computed: {
    actionPlans() {
      return store.getters["action_plan/getSelectedItems"];
    },
  },
};
</script>

<style></style>
